import Vue from 'vue'
import {MLInstaller, MLCreate, MLanguage} from 'vue-multilanguage'

Vue.use(MLInstaller);

export default new MLCreate({
    initial: 'en',
    save: process.env.NODE_ENV === 'production',
    languages: [
        new MLanguage('en').create({
            log_in: 'log in',
            log_out: 'Log out',
            tm_home_slogan: 'CHECK YOUR TRADEMARKS AUTOMATICALLY',
            SUBSCRIBE: 'SUBSCRIBE',
            FREE_TRIAL: 'FREE TRIAL',
            HOW_IT_WORKS: 'HOW IT WORKS',
            login: 'Login',
            button_login: 'Log In',
            sign_up: 'Sign Up',
            continue: 'Continue',
            forgot_password_q: 'Forgot password?',
            missing_account: 'Don\'t have an account?',
            first_name: 'First Name',
            last_name: 'Last Name',
            email: 'Email',
            password: 'Password',
            confirm_password: 'Confirm Password',
            registration_form: 'Enter your account details',
            company: 'Company',
            vat: 'VAT',
            address: 'Address',
            city: 'City',
            country: 'Country',
            billing: 'Billing Information',
            payment_options: 'Payment Options',
            card_number: 'Card Number',
            month: 'Month',
            year: 'Year',
            cvv: 'CVV',
            cvc: 'CVC',
            card_holder: 'Card Holder Name',
            products_in_cart: 'Product in your shopping cart',
            your_current_plan: 'Your current plan',
            PRICE: 'PRICE',
            TOTAL: 'TOTAL',
            Expiration_Date: 'Expiration Date',
            term_protection: 'Term protection',
            select_a_country: 'Select a country',
            RestorePassword: 'Restore Password',
            ForgottenPassword: 'Forgotten Password',
            ForgottenPasswordSuccess: 'Check your email to restore your account.',
            password_confirm: 'Confirm password',
            RestoreAccount: 'Restore Account',
            RestoreAccountSuccess: 'Your password has been successfully changed. You can proceed to the login.',
            ChangePassword: 'Change Password',
            track_trademarks: 'Track Trademarks',
            reports: 'Reports',
            search_in_database: 'Search In Database',
            upload_trademark: 'Upload Trademark',
            user_list: 'User List',
            owners_list: 'Owners List',
            monitored_trademarks: 'Monitored Trademarks',
            unmonitored_trademarks: 'Unmonitored Trademarks',
            add: 'Add',
            Filter: 'Filter',
            Search: 'Search',
            Search_Result: 'Search Result',
            Trademark: 'Trademark',
            Department: 'Department',
            Owner: 'Owner',
            Status: 'Status',
            current_status: 'Current status',
            IP_rep: 'IP rep',
            Date: 'Date',
            Monitoring: 'Monitoring',
            Back: 'Back',
            Registration_Number: 'Registration Number',
            Opposed_Service: 'Opposed Goods/Services',
            Reg_No: 'Reg No',
            Date_Of_Registration: 'Registration date',
            Reg_Date: 'Reg Date',
            Create_Date: 'Create date',
            Update_Date: 'Update date',
            Owners_Address: 'Owner\'s Address',
            Term_Of_Protection: 'Term Of Protection',
            Number_Of_Request: 'Number Of Request',
            Good_Service: 'Good/Service',
            Registration_Date: 'Registration Date',
            Search_For_Matches: 'Search For Matches',
            Data_Entry: 'Data Entry',
            Type: 'Type',
            type_mixed: 'Figurative with text element',
            type_verbal: 'Verbal',
            type_figurative: 'Figurative',
            type_audio: 'Audio',
            Kind: 'Kind',
            kind_individual: 'Individual',
            kind_collective: 'Collective/Certificate',
            Sound: 'Sound',
            Trademark_Monitoring: 'Trademark Monitoring',
            Yes: 'Yes',
            No: 'No',
            Basic_Information: 'Basic Information',
            Title: 'Title',
            new_word: 'new',
            Owner_Address: 'Owner Address',
            Representative: 'Representative',
            Address_Of_Representative: 'Address Of Representative',
            Logo: 'Logo',
            Drop_file_below: 'Drop file below',
            Your_Logo_Here: 'Your Logo<br>Here<br>',
            Chose_File: 'Chose File',
            Registration_Information: 'Registration Information',
            Application_Number: 'Application Number',
            Appl_No: 'Appl No',
            Application_Date: 'Application Date',
            Appl_Date: 'Appl Date',
            Term: 'Term',
            Country_Of_Registration: 'Country Of Registration',
            Country_Of_Origin: 'Country Of Origin',
            Countries: 'Countries',
            Designated_countries: 'Designated countries',
            Classes: 'Classes',
            Nice_Classes: 'Nice Classes',
            Add_Nice_Class: 'Add Nice Class',
            Cancel: 'Cancel',
            Save: 'Save',
            Registered_Trademarks: 'Registered Trademarks',
            Matches: 'Matches',
            Archive: 'Archive',
            Filter_By_Trademark: 'Filter By Trademark',
            Legal_Information: 'Legal Information',
            Search_By_Class: 'Search By Class',
            Vienna_Class: 'Vienna Class',
            Nice_Class: 'Nice Class',
            Request_Number: 'Request Number',
            Bulgarian_Patent_Company: 'Bulgarian Patent Company',
            OAMI: 'OAMI',
            WIPO: 'WIPO',
            Name: 'Name',
            Size: 'Size',
            Uploaded_By: 'Uploaded By',
            Plan: 'Plan',
            Role: 'Role',
            Active: 'Active',
            Activating_Account: 'Activating your account, please wait.',
            Account_Activation: 'Account Activation',
            Activating_Account_Success: 'Your account has been successfully activated.',
            home_header_text: 'TM Smart is a great tool for all patent law attorneys. TM Smart helps you track all your clients\' trademarks automatically in one place. Check your trademark information in <span class="qf-strong-warning">WIPO</span> and <span class="qf-strong-warning">OAMI</span>.',
            BUY: 'BUY',
            CONTACT: 'CONTACT',
            how_it_works_text_1: 'Chose the best plan for you and start registering trademarks you wnat to monitor in your region.',
            how_it_works_text_2: 'TM Smart helps you track all your clients\' trademarks in one place.',
            how_it_works_text_3: 'Check the results daily. Receive notifications for infringements.',
            how_it_works_text_4: 'Custom platform features. Contact us for more information.',
            Write_Permission: 'Write Permission',
            Daily: 'Daily',
            Check: 'Check',
            Check_Before: 'Check Before',
            Registration: 'Registration',
            Trademark_Monitoring_Home: 'Trademark<br>Monitoring',
            Daily_Check_Home: 'Daily<br>Check',
            Check_Before_Registration_home: 'Check Before<br>Registration',
            Users_Permissions_home: 'Users<br>Permissions',
            home_text_1: 'Track your trademarks for marches with newly registered trademarks.',
            home_text_2: 'Automated daily check of all your uploaded trade marks. Never miss a matching trademark.',
            home_text_3: 'Check trademarks before registration in local database.',
            home_text_4: 'Add users to a single account and give them permissions to check different TMs.',
            ABOUT_US: 'ABOUT US',
            about_text1: '<strong>We are a Swiss based comapny</strong> with more than 20 years of experience in softwere and service development. Our clients vary from big corporations to newley developing startups. TM Smart is a platform with 4 years running background and proven useability.',
            about_text2: '<strong>Bilyana Magardichian</strong> is a well known and proven patent law specialist with more than 10 years of experiance in the field. We partner in the TM Smart software to develope a good and well trusted platform.',
            about_text3: '<strong>We value privacy and security.</strong><br> As a Swiss company one of our key values is sequrity. All of our data is stored acording to all EU and Swiss regulations and situated on the heighest security servers in Switzerland. We guarantee our data is private and secure.',
            BEST_VALUE: 'BEST VALUE',
            up_to: 'up to',
            manuel_home: '<strong>Manuel<br>Krumenacher</strong><br>Partner, CEO',
            bilyana_home: '<strong>Bilyana<br>Magardichian</strong><br>Patent Layer, Partner',
            general_error_msg: 'Something went wrong.',
            Person: 'Person',
            Company: 'Company',
            Result: 'Result',
            Matching: 'Matching',
            NCL: 'NCL',
            VCL: 'VCL',
            Monitored_trademark: 'Monitored trademark',
            Time_to_respond: 'Time to respond',
            day: 'day',
            days: 'days',
            Patent_Office: 'Patent Office',
            all: 'all',
            all_trademarks: 'All Trademarks',
            add_opposition: 'Add Opposition',
            edit_opposition: 'Edit Opposition',
            oppositions: 'Oppositions',
            opposed_trademark: 'Opposed Trademark',
            office: 'Office',
            procedure_number: 'Procedure Number',
            status_open: 'Open',
            status_suspended: 'Suspended',
            status_for_decision: 'For Decision',
            status_ended: 'Ended',
            coolingoff_period_ends_date: 'Cooling-Off Period End Date',
            observation_in_reply: 'Observation in Reply',
            extension: 'Extension',
            ffae_ends: 'FFAE Ends',
            earlier_trademark: 'Earlier Trademark',
            opponent: 'Opponent',
            applicant: 'Applicant',
            owner_name: 'Earlier Trademark Owner Name',
            opposition_details: 'Opposition Details',
            Trademark_Details: 'Trademark Details',
            browse_oppositions_for_tm: 'Browse Oppositions For TM',
            Files: 'Attached Files',
            Colors: 'Colors',
            Number: 'Number',
            Tracking_Criteria: 'Tracking Criteria',
            Vienna_Classes: 'Vienna Classes',
            Image: 'Image',
            Save_And_Continue: 'Save And Continue',
            Edit: 'Edit',
            Filter_By_Owner: 'Filter By Owner',
            Filter_By_Type: 'Filter By Type',
            Show_Hidden: 'Show Hidden',
            Result_Trademark: 'Result Trademark',
            phone: "Phone",
            send: "SEND",
            how_can_we_help: "HOW CAN WE HELP?",
            DATENSCHUTZ: "DATENSCHUTZ",
            GDPR: "GDPR",
            AGB: "AGB",
            Contestation: "Contestation",
            Delete: 'Delete',
            Profile_Information: 'Profile Information',
            VAT_Number: 'VAT Number',
            Cancel_plan: 'Cancel plan',
            extend: 'Extend',
            Extend_plan: 'Extend plan',
            Extend_current_plan: 'Extend current plan',
            upgrade: 'Upgrade',
            Upgrade_plan: 'Upgrade plan',
            Upgrade_to: 'Upgrade to',
            Upgrade_to_PRO: 'Upgrade to PRO',
            PRO: 'PRO',
            Date_Purchased: 'Date Purchased',
            Date_Activated: 'Date Activated',
            Valid_To: 'Valid To',
            Download_invoice: 'Download invoice',
            Tracked_by: 'Tracked by',
            AccessToTrademarkOwner: 'Access To Trademark Owner',
            select_owner: 'Select Owner',
            Assistant: 'Assistant',
            TrademarkOwner: 'Trademark Owner',
            no_users_added: 'No users added',
            current_plan_is_extended: 'Current plan is extended with one year',
            Close: 'Close',
            not_available: 'N/A',
            Select_Plan_To_Upgrade: 'Select Plan To Upgrade',
            Selected_Plan: 'Selected Plan',
            add_trademark: 'Add Trademark',
            edit_trademark: 'Edit Trademark',
            upload_file: 'Upload file',
            Select_status: 'Select status',
            status_filed: 'Application filed',
            status_published: 'Application published',
            status_registration_pending: 'Registration pending',
            status_registered: 'Registered',
            status_withdrawn: 'Application withdrawn',
            status_refused: 'Application refused',
            status_opposed: 'Application opposed',
            status_pending: 'Appeal pending',
            status_cancellation_procedure: 'Registration cancellation pending',
            status_cancelled: 'Registration cancelled',
            status_surrendered: 'Registration surrendered',
            status_expired: 'Registration expired',
            comments: 'Comments',
            add_comments: 'Add comments',
            notes: 'Notes',
            add_notes: 'Add notes',
            no_results_found: 'No results found',
            Trademarks_owned: 'Trademarks owned',
            Add_New_Owner: 'Add New Owner',
            Edit_Owner: 'Edit Owner',
            Delete_Owner: 'Delete Owner',
            Move_brand_to_owner: 'Transfer trademarks owned by <strong>{ownerName}</strong> by to',
            Delete_Owner_heading: 'Are you sure you want to delete',
            Brand_Owners: 'Brand Owners',
            Browse_Reports_For_TM: 'Browse Reports For TM',
            Keywords: 'Keywords',
            Trademark_Monitoring_Keywords: 'Trademark Monitoring Keywords',
            Filters: 'Filtesr',
            All_types: 'All types',
            All_owners: 'All owners'
        }),
        new MLanguage('bg').create({
            log_in: 'log in',
            log_out: 'Log out',

            filed: 'Заявена',
            published: 'Публикувана',
            registration_pending: 'Висяща регистрация',
            registered: 'Регистрирана',
            withdrawn: 'Оттеглена',
            refused: 'Отказана',
            opposed: 'Подадена опозиция',
            pending: 'Висяща жалба',
            cancellation_procedure: 'Процедура по заличаване',
            cancelled: 'Оттеглена',
            surrendered: 'Предварителен отказ',
            expired: 'Угаснала',
            comments: 'Добавете коментар',
            add_comments: 'Коментар',
            notes: 'Коментар',
            add_notes: 'Добавете коментар',
            no_results_found: 'Няма намерени резултати',
            Trademarks_owned: 'Trademarks owned',
        }),
        new MLanguage('de').create({
            log_in: 'Anmeldung',
            log_out: 'Abmelden',

            filed: 'Anmeldung eingereicht',
            published: 'Anmeldung veröffentlicht',
            registration_pending: 'Eintragung anhängig',
            registered: 'Eingetragen',
            withdrawn: 'Anmeldung zurückgezogen',
            refused: 'Anmeldung zurückgewiesen',
            opposed: 'Anmeldung angefochten',
            pending: 'Beschwerde anhängig',
            cancellation_procedure: 'Löschung der Eintragung anhängig',
            cancelled: 'Eintragung gelöscht',
            surrendered: 'Auf Eintragung verzichtet',
            expired: 'Eintragung abgelaufen',
            comments: 'Kommentare',
            add_comments: 'Kommentare hinzufügen',
            notes: 'Notizen',
            // notes: 'Notizen hinzufügen',
            no_results_found: 'Кeine Ergebnisse gefunden',
            Trademarks_owned: 'Trademarks owned',
        })
    ]
})
